import Typography from '@ausbom/typography';
import React from 'react';
import { STRINGS } from '../../constants';
import Link from '../Link';
import './AppFooter.scss';
import footerImgUrl from './footer_logo.svg';

type FooterProps = {
  baseUrl?: string;
};

const navLinks = [
  { href: `mailto:${STRINGS.CONTACT_EMAIL}`, title: 'Support', email: true },
  { href: '/other/disclaimer.shtml', title: 'Disclaimer' },
  { href: '/other/privacy.shtml', title: 'Privacy' },
  { href: '/other/accessibility.shtml', title: 'Accessibility' }
];

type NavLinksProps = { baseUrl?: string };

const NavLinks: React.FC<NavLinksProps> = ({ baseUrl }) => {
  return (
    <div className="component">
      <nav role="navigation" aria-label="Footer navigation links">
        <ul>
          {navLinks.map((link, idx) => (
            <li key={`f-${idx}`}>
              <Link
                style="footer"
                href={link?.email ? link.href : `${baseUrl}${link.href}`}
                blank={true}
                external={true}
                title={link.title}
              />
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default function AppFooter({ baseUrl }: FooterProps) {
  const rootUrl = baseUrl ?? 'https://www.bom.gov.au';
  const year = new Date().getFullYear();

  return (
    <footer role="contentinfo" aria-label="Page footer" className="wdh-footer">
      <div className="wdh-footer__container">
        <div className="left">
          <Typography as="div" styleName="body-s">
            <Typography as="p" styleName="body-s">
              We acknowledge the traditional custodians of Australia, and their continuing connection to land, sea, and
              community. We respect their Elders, past and present, and all Aboriginal and Torres Strait Islander
              nations.
            </Typography>
            <NavLinks baseUrl={rootUrl} />
          </Typography>
        </div>
        <div className="divider"></div>
        <div className="right">
          <Link
            style="footer"
            href={rootUrl}
            external={true}
            blank={true}
            title="Australian Government Bureau of Meteorology logo"
          >
            <img
              src={footerImgUrl}
              alt="Australian Government Bureau of Meteorology logo"
              aria-label="Australian Government Bureau of Meteorology logo"
            />
          </Link>
          <div className="component">
            <Typography as="p" styleName="body-s" className="copyright">
              <Link
                style="footer"
                href={`${rootUrl}/other/copyright.shtml`}
                external={true}
                blank={true}
                title="Copyright Notice"
              >
                Copyright
              </Link>{' '}
              &copy; Commonwealth of Australia {year}, The Bureau of Meteorology
            </Typography>
          </div>
        </div>
      </div>
    </footer>
  );
}
